var factories = new Map();
export function registerRenderer(type, factory) {
    factories.set(type, factory);
}
export function createRenderer(type) {
    var factory = factories.get(type);
    return factory ? factory() : null;
}
export function hasRenderer(type) {
    return factories.has(type);
}
/** Test hook — reset renderer registry. */
export function clearRenderers() {
    factories.clear();
}
